import { SystemAuthorizations } from 'shell/authorizations/system';
import { HeadCell } from 'shell/components/shared/table/types';
import { QualificationClient } from './types';
import * as yup from 'yup';

export const authsObj = Object.freeze({
  read: [SystemAuthorizations.QualificaQuery],
  create: [SystemAuthorizations.QualificaAdd],
  edit: [SystemAuthorizations.QualificaUpdate],
  delete: [SystemAuthorizations.QualificaDelete],
});

export const validationSchemaQualificationsFilter = yup.object({});

export const headCells: HeadCell<QualificationClient, keyof QualificationClient>[] = [
  {
    id: 'code',
    label: 'Codice',
  },
  {
    id: 'description',
    label: 'Descrizione',
  },
  {
    id: 'action',
    label: '',
  },
];
